import React, { useState } from 'react';
import CreateValidity from './createValidity';
import ApplicationList from './ApplicationList';
import ResourceList from './ResourceList';
import { MONTH_VALIDITY } from '../../Constant/constant';


const ValiditySection = () => {

    return (
        <>
            <div className="colorborder">
                <div className="validity-page">

                    <CreateValidity />

                    <div className="validitypage-application">
                        <ApplicationList />
                    </div>

                    <div className="validitypage-application mt-4">
                        <ResourceList />
                    </div>

                </div>
            </div>
        </>
    )
}

export default ValiditySection;